/* eslint-disable consistent-return */
/* eslint-disable no-undef */
import React, { useState, useRef } from 'react';
import Loader from '../../Common/Loader';
import Filter from './Filter';
import moment from 'moment-timezone';
import { CSVLink } from 'react-csv';
import XMLViewer from 'react-xml-viewer';
import axios from 'axios';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import constants from '../../../constants';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const SyncLogWrapper = () => {
  const [list, setList] = useState([]);
  const [csv, setCsv] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageRangeDisplayed] = useState(5);
  const [counter, setCounter] = useState(0);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [showPopup, setShowPopup] = useState([]);
  const [card, setCard] = useState(false);
  const [xmls, setXmls] = useState({ request_xml: '<xml></xml>', response_xml: '<xml></xml>' });
  const [searchParam, setSearchParam] = useState({
    hotelId: '',
    bookingId: '',
    status: '',
    requestType: '',
    date: ''
  });
  const csvRef = useRef();
  const [mongoId, setMongoId] = useState(null);

  const setMessageFunc = (type, message) => {
    setFlag(true);
    setType(type);
    setMessage(message);
    setTimeout(() => setFlag(false), 3000);
  };

  const getSyncLogs = () => {
    setShowUILoader(true);
    axios(serverUrl + 'logs/getsynclogs', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { page: pageNumber, limit: limit, searchParam: searchParam }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setList(response.data.data);
          setTotal(response.data.count);
        } else {
          setMessageFunc('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const getXmls = (type, mongoId) => {
    setShowUILoader(true);
    setMongoId(mongoId);
    if (typeof showPopup[mongoId] === 'undefined') {
      axios(serverUrl + 'logs/getxmls', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: { mongoId: mongoId }
      })
        .then(response => {
          let newShowPopup = { ...showPopup };
          let newXmls = { ...xmls };
          newShowPopup[mongoId] = response.data.data;
          newXmls.request_xml = response.data.data.request_xml !== '' ? response.data.data.request_xml : 'Invalid request';
          newXmls.response_xml = response.data.data.response_xml !== '' ? response.data.data.response_xml : 'Invalid response';
          setShowPopup(newShowPopup);
          setXmls(newXmls);
          setCard(true);
          setShowUILoader(false);
        })
        .catch(error => {
          console.log(error);
          setShowUILoader(false);
        });
    } else {
      let newShowPopup = { ...showPopup };
      let newXmls = { ...xmls };
      newXmls.request_xml = newShowPopup[mongoId].request_xml !== '' ? newShowPopup[mongoId].request_xml : 'Invalid request';
      newXmls.response_xml = newShowPopup[mongoId].response_xml !== '' ? newShowPopup[mongoId].response_xml : 'Invalid response';
      setXmls(newXmls);
      setCard(true);
      setShowUILoader(false);
    }
  };

  const renderSyncLogsList = () => {
    if (Object.keys(list).length > 0) {
      return Object.keys(list).map(id => {
        var data = list[id];
        return (
          <div className="table_row border_t_1 border_color_1" key={id}>
            <div className="tabcel align_middle pad10">{data.hotel}</div>
            <div className="tabcel align_middle pad10">{data.request_type}</div>
            <div className="tabcel align_middle pad10">
              {data.status + ' '}
              {data.status === 'Error' ? (
                <div className="inline align_middle">
                  <div className="ft align_middle tooltip">
                    <div className="ovr cursor_p">
                      <i className="fa fa-info fnt12 cursor_p color5_2"></i>
                    </div>
                    <div className="tooltip_col tipleft hides">
                      <div className="tip_arrow">
                        <span className="tip_nov"></span>
                      </div>
                      <div className="tooltip_cover wdhpx300 bgcolr1 shwd1 ovr pad10">
                        <div>
                          <span className="bld">Message : </span>
                          {data.error_message}
                        </div>
                        <div className="padtop3">
                          <span className="bld">Retry Count : </span>
                          {data.retry_count}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="tabcel align_middle pad10">{data.created_on}</div>
            <div className="tabcel align_middle pad10">{data.user}</div>
            <div className="tabcel align_middle pad10">
              <div className="row gutters-3 fnt16">
                <div className="col-xs-4 tc">
                  <a
                    className="inline align_middle"
                    href="#"
                    title="XMLs"
                    onClick={e => { e.preventDefault(); getXmls('show', data.mongo_id); }}
                  >
                    <i className="fa fa-eye"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      });
    }
  };

  const handlePageChange = pageNumber => {
    var counter = pageNumber <= 1 ? 0 : (pageNumber - 1) * limit;
    setPageNumber(pageNumber);
    setCounter(counter);
    getSyncLogs();
  };

  const dateChange = (date, type) => {
    const newDate = moment(date).format('YYYY-MM-DD');
    setSearchParam(prev => ({ ...prev, [type]: newDate }));
  };

  const paramChange = (e, type) => {
    if (type === 'hotelName') {
      setSearchParam(prev => ({
        ...prev,
        hotelName: e.length > 0 ? e[0].hotel : '',
        hotelId: e.length > 0 ? e[0].hotel_id : ''
      }));
    } else {
      setSearchParam(prev => ({ ...prev, [type]: e.target.value }));
    }
  };

  const searchSyncLogs = () => {
    var flag = true;
    var msg = 'Please Select Criteria for search.';
    if (searchParam.hotelId !== '') flag = false;
    if (searchParam.bookingId !== '') flag = false;
    if (searchParam.status !== '') flag = false;
    if (searchParam.requestType !== '') flag = false;
    if (searchParam.date !== '') flag = false;
    if (flag) {
      setFlag(true);
      setType('error');
      setMessage(msg);
      setTimeout(() => setFlag(false), 5000);
    } else {
      setPageNumber(1);
      setCounter(0);
      getSyncLogs();
    }
  };

  const reset = () => {
    setSearchParam({ hotelId: '', bookingId: '', status: 0, requestType: '', date: '' });
    setPageNumber(1);
    setCounter(0);
    setList([]);
    setTotal(0);
  };

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">PMS Logs</div>
          </div>
          <CSVLink data={csv} ref={csvRef} filename="bookings.csv" />
        </div>
      </div>
      {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>{message}</div>
      ) : ''}
      <Filter
        params={searchParam}
        dateChange={dateChange}
        paramChange={paramChange}
        searchSyncLogs={searchSyncLogs}
        reset={reset}
      />
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="cover border_all_1 border_color_1">
          <div className="scrolly_auto">
            <div className="table_col table_fixed">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx220">Hotel</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Request Type</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Status</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Date</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">User</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">XML</div>
              </div>
              {renderSyncLogsList()}
            </div>
          </div>
          {total === 0 && !showUILoader ? (
            <div className="cover pad30 border_t_1 border_color_1">
              <div className="ovr tc marg_bottom10">
                <div className="inline">
                  <img src="/images/no_result.png" alt="No Logs Found" />
                </div>
              </div>
              <div className="ovr tc fnt16 bld">No Logs Found</div>
            </div>
          ) : ''}
        </div>
        {total > limit ? (
          <div className="cover tc margtop15">
            {/* <Pagination
              activePage={pageNumber}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={pageRangeDisplayed}
              onChange={handlePageChange}
            /> */}
          </div>
        ) : ''}
      </div>
      <div className={`modal_wrap posfixed ${card ? '' : 'hides'}`}>
        <div className="modal_overlay transbg1">&nbsp;</div>
        <div className="pop_colum">
          <div className="pop_inner">
            <div className="apndwrap wdhpx900 shwd2 bg1 pad30 round5 ovr zIndex999">
              <div className="popup_scroll">
                <div
                  className="close_popup facnt full-round bgcolr6"
                  onClick={() => {
                    setCard(false);
                    setXmls({ request_xml: '<xml></xml>', response_xml: '<xml></xml>' });
                  }}
                >
                  <i className="fa fa-times txtcolr1"></i>
                </div>
                <div className="wrapper">
                  <div className="cover marg_bottom10 text-start">
                    <div className="cover marg_bottom15">
                      <div className="ovr marg_bottom5 bld text-start">Request XML</div>
                      <div className="ovr marg_bottom5 marg_top15 text-start">
                        <XMLViewer xml={xmls.request_xml} />
                      </div>
                      <div className="ovr marg_bottom5 bld text-start">Response XML</div>
                      <div className="ovr marg_bottom5 marg_top15 text-start text-start">
                        <XMLViewer xml={xmls.response_xml} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SyncLogWrapper;
